<div class="inner-scroll login-main">
  <div class="absolute inset-0 top-0 left-0">
    <img src="../images/new/dark-material-bg.jpg" class="h-full object-cover"/>
</div>
  @if(!linkExpired){
    
  <div
      class="login-wrapper bg-white">

      <div class="p-relative w-full shadow-none" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
        <!-- Logo -->
        <div class="w-40 m-auto">
            <img src="../images/new/biz-logo.png" alt="Logo">
       </div>

        <!-- Title -->
        <div class="mt-5 auth-title">
          Recover your security code
        </div>
        @if(apiResponseErrorMessage!=null){
          <div class="message-box error mb-3">
            <span class="custom-span-pre">{{apiResponseErrorMessage}}</span>
          </div>
          }
      <form class="mt-8" name="formRecoverSecurityCode" [formGroup]="formRecoverSecurityCode" (submit)="recoverSecurityCode()"
        novalidate>
       
        <!--<mat-form-field>
          <input type="text" matInput placeholder="Recovery code" parent="true" color="primary" formControlName="currentCode">
        </mat-form-field>-->

        <mat-form-field class="w-full">
          <mat-label>Enter New Code</mat-label>
          <input type="password" matInput placeholder="Enter New Code" required color="primary"
            formControlName="newCode">
          <mat-error>
            @if(formRecoverSecurityCode.get('newCode').hasError('required')){
            <span>New code is required.</span>
            }
            @if(!formRecoverSecurityCode.get('newCode').hasError('required') &&
            formRecoverSecurityCode.get('newCode').hasError('maxlength')){
            <span>
              Maximum 4 digit allowed.
            </span>
            }
          </mat-error>
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>Enter Confirm Code</mat-label>
          <input type="password" matInput placeholder="Enter Confirm Code" required color="primary"
            formControlName="confirmCode">
          <mat-error>
            @if(formRecoverSecurityCode.get('confirmCode').hasError('required')){
            <span>Confirm code is required</span>
            }
            @if(!formRecoverSecurityCode.get('confirmCode').hasError('required') &&
            formRecoverSecurityCode.get('confirmCode').hasError('codeNotMatching')){
            <span>
              New code and confirm code are not same.
            </span>
            }
          </mat-error>
        </mat-form-field>
        <button type="submit" mat-raised-button color="primary" class="fuse-mat-button-large submit-button bg-primary text-white w-full mt-0"
          [disabled]="!formRecoverSecurityCode.valid">
          Recover Security Code
        </button>
       

      </form>
      <div class="text-secondary text-center mt-4 text-md font-medium">
        <span>Return to</span>
        <a
            class="ml-1 text-primary-500 hover:underline"
            [routerLink]="['/sign-in']"
            >sign in
        </a>
    </div>
    </div>
  </div>
  }
  @if(linkExpired){
    <div
        class="login-wrapper bg-white"
    >
    <div class="p-relative w-full shadow-none">
            <!-- Logo -->
            <div class="w-40 m-auto">
                <img src="../images/new/biz-logo.png" alt="Logo">
            </div>

            <!-- Title -->
            <div class="mt-5 auth-title text-2xl">
              Link expired
            </div>
            <div class="mt-0.5 font-medium text-center">
              Link you tried to access is expired.
            </div>

            <!-- Form footer -->
            <div class="mt-8">
                <div class="text-secondary text-center mt-4 text-md font-medium">
                    <span>Return to</span>
                    <a
                        class="ml-1 text-primary-500 hover:underline"
                        [routerLink]="['/sign-in']"
                        >Sign In
                    </a>
                </div>
            </div>
        </div>
    </div>
  }

</div>